import mod from "-!./Settings.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Settings.js?vue&type=script&lang=js&external"